import * as React from 'react';
import * as styles from './Team.module.scss';
import PageInfo from "../../../common/PageInfo/PageInfo";
import CarouselItem from '../../../common/Carousel/CarouselItem/CarouselItem';

const Team = () => (
  <section className={styles.root}>
    <div className={styles.backgroundImage}/>
    <div className={styles.containerWrapper}>
      <CarouselItem title1='Team'
                    subtitle1='Who we are'
                    description='Flatfy is a team of dynamic individuals with a passion for technology. We’ve been working with real estate tech incorporate our experience from other products for the past 10 years and strive to make our cities more comfortable, safe and modern.'
                    // detailsPath='/team'
                    // detailsText='Read more'
      />
      <PageInfo text={'05 - team'}/>
    </div>
  </section>
);

export default Team;
